// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
* {
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

.weather {
  margin-left: -8%;
}

.main {
  min-height: 80vh;
}

.main-heading {
  margin: 0;
  margin-bottom: 1vh;
  text-align: left;
  padding: 0 2vw;
  background-image: linear-gradient(to left, #fff, #2c53a0);
  color: #fff;
  position: sticky;
  width: 100%;
  text-transform: none;
  font-size: 2rem;
}
@media (max-width: 1000px) {
  .main-heading {
    font-size: 1.5rem;
  }
}
@media (max-width: 600px) {
  .main-heading {
    font-size: 1.2rem;
  }
}

header {
  display: flex;
  padding: 1% 3%;
  justify-content: space-between;
  align-items: center;
  background-color: #2c53a0;
}
header .logo {
  width: 5%;
}
header h1 {
  color: #fff;
  font-size: 4rem;
  text-transform: uppercase;
  cursor: pointer;
}
header h1 span {
  color: #64c4e0;
}
header nav p {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
header nav p:hover {
  border-bottom: 1px solid #fff;
  transform: scale(1.2);
}

main {
  display: flex;
  flex-direction: column;
  background-color: #e4ffff;
  overflow-x: none;
}

.level {
  min-height: 75vh;
}
.level h2 {
  text-align: center;
}
.level .row {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: auto;
}
.level .row select {
  width: 40%;
  border: 1px solid #64c4e0;
  border-radius: 1rem;
  font-size: 1.2rem;
  background-color: #fff;
}
.level .showSite {
  margin-top: 2%;
}

.home {
  min-height: 75.4vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
}
.home .topBar {
  display: flex;
  width: 90%;
  margin: 2% auto;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.home .topBar .fuelHistory {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  flex-wrap: wrap;
  width: 50%;
}
.home .topBar .fuelHistory .siteHistory {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 50%;
  align-items: center;
}
.home .topBar .fuelHistory .siteHistory table {
  width: 90%;
  border: 1px solid #4d4d4d;
  color: #4d4d4d;
  border-collapse: collapse;
  table-layout: fixed;
}
.home .topBar .fuelHistory .siteHistory table tr,
.home .topBar .fuelHistory .siteHistory table th,
.home .topBar .fuelHistory .siteHistory table td {
  border: 1px solid #4d4d4d;
  justify-items: center;
  text-align: center;
  padding: 1%;
  align-self: center;
}
.home .topBar .fuelHistory .siteHistory table tr .increase,
.home .topBar .fuelHistory .siteHistory table th .increase,
.home .topBar .fuelHistory .siteHistory table td .increase {
  color: #0f0;
  margin-top: 5%;
}
.home .topBar .fuelHistory .siteHistory table tr .decrease,
.home .topBar .fuelHistory .siteHistory table th .decrease,
.home .topBar .fuelHistory .siteHistory table td .decrease {
  color: rgb(255, 0, 0);
  margin-top: 20%;
}
.home .topBar .fuelHistory .siteHistory table tr:nth-child(even) {
  background-color: #f2f2f2;
}
.home .topBar .rightSide {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30vw;
}
.home .topBar .rightSide .current {
  width: 90%;
  margin: auto;
  border-radius: 1rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  display: flex;
  flex-direction: column;
  margin: 2% 0;
  background-color: #fff;
}
.home .topBar .rightSide .current b {
  text-align: center;
  color: #4d4d4d;
}
.home .topBar .rightSide .current .prices {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.home .topBar .rightSide .current .prices .latest {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.home .topBar .rightSide .current .prices .latest p {
  display: flex;
  justify-content: center;
  align-items: center;
}
.home .topBar .rightSide .current .prices img {
  width: 5%;
}
.home .topBar .rightSide .current .prices:nth-child(1) {
  justify-content: center;
}
.home .topBar .rightSide .wrapper {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  height: 350px;
}
.home .topBar .rightSide .wrapper .chart {
  width: 44vw;
}

.sites {
  min-height: 74.8vh;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin: 3% auto;
}
.sites .banner {
  border: 5px solid #000;
  border-radius: 0.5rem;
  width: 12vw;
  height: 100vh;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: relative;
}
.sites .banner .bpSite {
  font-family: "digital-clock-font";
  background-color: black;
  color: white;
  text-align: center;
  margin-top: -4px;
  margin-bottom: 15px;
  font-size: 1.7rem;
}
.sites .banner .bottom {
  align-self: flex-end;
  position: absolute;
  bottom: 0;
}
.sites .banner .indvPrice {
  display: flex;
  justify-content: space-between;
  margin-bottom: -15%;
}
.sites .banner .indvPrice .fuelType {
  font-size: 1.2rem;
  margin-top: 25%;
}
.sites .banner .indvPrice .bpBoard {
  font-family: "digital-clock-font";
  background-color: black;
  color: white;
  font-size: 3rem;
}

footer {
  display: flex;
  justify-content: center;
  background-color: #2c53a0;
}
footer p {
  color: #fff;
}
footer p a {
  text-decoration: none;
  color: #64c4e0;
}

@media (max-width: 600px) {
  header .logo {
    width: 30%;
  }
  header h1 {
    font-size: 1.2rem;
  }
  header nav {
    width: 50%;
  }
  header nav span {
    display: none;
  }
  main h2 {
    font-size: 1.2rem;
  }
  main .home .topBar {
    flex-direction: column;
  }
  main .home .topBar .fuelHistory {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 85vw;
    align-items: flex-start;
    margin-right: auto;
  }
  main .home .topBar .fuelHistory .siteHistory {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100vw;
    align-items: center;
  }
  main .home .topBar .fuelHistory .siteHistory table {
    width: 90%;
    border: 1px solid #4d4d4d;
    color: #4d4d4d;
    border-collapse: collapse;
    table-layout: fixed;
  }
  main .home .topBar .fuelHistory .siteHistory table tr,
  main .home .topBar .fuelHistory .siteHistory table th,
  main .home .topBar .fuelHistory .siteHistory table td {
    border: 1px solid #4d4d4d;
    justify-items: center;
    text-align: center;
    padding: 1%;
    align-self: center;
  }
  main .home .topBar .fuelHistory .siteHistory table tr .increase,
  main .home .topBar .fuelHistory .siteHistory table th .increase,
  main .home .topBar .fuelHistory .siteHistory table td .increase {
    color: #0f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  main .home .topBar .fuelHistory .siteHistory table tr .decrease,
  main .home .topBar .fuelHistory .siteHistory table th .decrease,
  main .home .topBar .fuelHistory .siteHistory table td .decrease {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: rgb(255, 0, 0);
  }
  main .home .topBar .fuelHistory .siteHistory table tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  main .home .topBar .rightSide {
    width: 90vw;
    margin: auto;
  }
  main .home .topBar .rightSide .current {
    width: 100%;
    margin: 2% auto;
  }
  main .home .topBar .rightSide .current p {
    font-size: 0.8rem;
  }
  main .home .topBar .rightSide .current .prices img {
    width: 20%;
  }
  main .home .topBar .rightSide .current .prices .latest p {
    font-size: 0.7rem;
  }
  main .home .topBar .rightSide .wrapper {
    margin-top: 3%;
    overflow: hidden;
  }
  main .home .topBar .rightSide .wrapper .chart {
    border: none;
    margin-left: -7%;
  }
  .sites {
    flex-wrap: wrap;
  }
  .sites .banner {
    width: 40vw;
    height: 82vh;
    margin-bottom: 3%;
  }
  .sites .banner .indvPrice {
    margin-bottom: -42%;
  }
  .sites .banner .indvPrice .fuelType {
    font-size: 0.9rem;
  }
  .sites .banner .indvPrice .bpBoard {
    font-size: 2.5rem;
    margin-top: 20%;
  }
  .sites .banner .bottom {
    margin-top: 10%;
  }
  .level {
    min-height: 80vh;
  }
  .level .row select {
    width: 60%;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  header .logo {
    width: 30%;
  }
  header h1 {
    font-size: 1.2rem;
  }
  header nav {
    width: 50%;
  }
  header nav span {
    display: none;
  }
  main h2 {
    font-size: 1.2rem;
  }
  main .home .topBar {
    align-items: center;
    flex-direction: column;
  }
  main .home .topBar .rightSide {
    width: 80vw;
  }
  main .home .topBar .rightSide .current {
    width: 95%;
    margin: 2% auto;
  }
  main .home .topBar .rightSide .current p {
    font-size: 0.8rem;
  }
  main .home .topBar .rightSide .current .prices img {
    width: 20%;
  }
  main .home .topBar .rightSide .wrapper {
    margin: 2% auto;
  }
  main .home .topBar .rightSide .wrapper .chart {
    width: 85vw;
  }
  main .home .topBar .weather {
    display: none;
  }
  main .home .topBar .fuelHistory {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 90vw;
    align-items: flex-start;
    margin-bottom: 5vh;
  }
  main .home .topBar .fuelHistory .siteHistory {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 50%;
    align-items: center;
  }
  main .home .topBar .fuelHistory .siteHistory table {
    width: 90%;
    border: 1px solid #4d4d4d;
    color: #4d4d4d;
    border-collapse: collapse;
    table-layout: fixed;
  }
  main .home .topBar .fuelHistory .siteHistory table tr,
  main .home .topBar .fuelHistory .siteHistory table th,
  main .home .topBar .fuelHistory .siteHistory table td {
    border: 1px solid #4d4d4d;
    justify-items: center;
    text-align: center;
    padding: 1%;
    align-self: center;
  }
  main .home .topBar .fuelHistory .siteHistory table tr .increase,
  main .home .topBar .fuelHistory .siteHistory table th .increase,
  main .home .topBar .fuelHistory .siteHistory table td .increase {
    color: #0f0;
    margin-top: 5%;
  }
  main .home .topBar .fuelHistory .siteHistory table tr .decrease,
  main .home .topBar .fuelHistory .siteHistory table th .decrease,
  main .home .topBar .fuelHistory .siteHistory table td .decrease {
    color: rgb(255, 0, 0);
    margin-top: 20%;
  }
  main .home .topBar .fuelHistory .siteHistory table tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  .sites {
    flex-wrap: wrap;
  }
  .sites .banner {
    width: 48vw;
    height: 82vh;
    margin-bottom: 3%;
  }
  .sites .banner .indvPrice {
    margin-bottom: -20%;
  }
  .sites .banner .indvPrice .fuelType {
    font-size: 1.5rem;
    margin-top: 16%;
  }
  .sites .banner .indvPrice .bpBoard {
    font-size: 3.5rem;
  }
  .sites .banner .bottom {
    margin-top: 5%;
  }
}
@media (min-width: 768px) and (max-width: 1025px) {
  header h1 {
    font-size: 2rem;
  }
  header nav span {
    display: none;
  }
  .main .home .topBar {
    display: flex;
    justify-content: space-between;
    width: 95vw;
  }
  .main .home .topBar .rightSide {
    width: 40%;
  }
  .main .home .topBar .rightSide .current {
    width: 100%;
  }
  .main .home .topBar .rightSide .wrapper .chart {
    width: 40vw;
  }
}
@media (min-width: 900px) {
  header .logo {
    width: 25%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/App.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI,sBAAA;EACA,iCAAA;AAIJ;;AADA;EACI,gBAAA;AAIJ;;AADA;EACI,gBAAA;AAIJ;;AADA;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yDAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;AAIJ;AAHI;EAXJ;IAYQ,iBAAA;EAMN;AACF;AALI;EAdJ;IAeQ,iBAAA;EAQN;AACF;;AALA;EACI,aAAA;EACA,cAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBDvCQ;AC+CZ;AANI;EACI,SAAA;AAQR;AALI;EACI,WAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAOR;AALQ;EACI,cDnDC;AC0Db;AADQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAGZ;AADY;EACI,6BAAA;EACA,qBAAA;AAGhB;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,yBDzES;EC0ET,gBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;AAEI;EACI,kBAAA;AAAR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AADR;AAGQ;EACI,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;AADZ;AAKI;EACI,cAAA;AAHR;;AAOA;EACI,kBAAA;EDvCA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECsCA,eAAA;AADJ;AAEI;EACI,aAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;ED1BJ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AC2BJ;AADQ;ED7BJ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EC6BQ,eAAA;EAEA,UAAA;AAIZ;AADY;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,mBAAA;AAGhB;AAFgB;EACI,UAAA;EACA,yBAAA;EACA,cDpIR;ECqIQ,yBAAA;EACA,mBAAA;AAIpB;AAFoB;;;EAGI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAIxB;AAFwB;;;EACI,WAAA;EACA,cAAA;AAM5B;AAHwB;;;EACI,qBAAA;EACA,eAAA;AAO5B;AAFwB;EACI,yBAAA;AAI5B;AAGQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AADZ;AAGY;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AADhB;AAGgB;EACI,kBAAA;EACA,cDvLR;ACsLZ;AAIgB;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;AAFpB;AAIoB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAFxB;AAIwB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAF5B;AAMoB;EACI,SAAA;AAJxB;AAOoB;EACI,uBAAA;AALxB;AAUY;EACI,2CAAA;EACA,aAAA;AARhB;AAUgB;EACI,WAAA;AARpB;;AAeA;EACI,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;AAZJ;AAcI;EACI,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,kBAAA;AAbR;AAeQ;EACI,iCAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAbZ;AAgBQ;EACI,oBAAA;EACA,kBAAA;EACA,SAAA;AAdZ;AAiBQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAfZ;AAiBY;EACI,iBAAA;EACA,eAAA;AAfhB;AAkBY;EACI,iCAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAhBhB;;AAsBA;EACI,aAAA;EACA,uBAAA;EACA,yBD9RQ;AC2QZ;AAoBI;EACI,WAAA;AAlBR;AAoBQ;EACI,qBAAA;EACA,cDnSC;ACiRb;;AAuBA;EAEQ;IACI,UAAA;EArBV;EAwBM;IACI,iBAAA;EAtBV;EAyBM;IACI,UAAA;EAvBV;EAyBU;IACI,aAAA;EAvBd;EA6BM;IACI,iBAAA;EA3BV;EA+BU;IAEI,sBAAA;EA9Bd;EAgCc;IACI,aAAA;IACA,eAAA;IACA,8BAAA;IACA,WAAA;IACA,uBAAA;IACA,kBAAA;EA9BlB;EAgCkB;IACI,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,YAAA;IACA,mBAAA;EA9BtB;EA+BsB;IACI,UAAA;IACA,yBAAA;IACA,cDrVhB;ICsVgB,yBAAA;IACA,mBAAA;EA7B1B;EA+B0B;;;IAGI,yBAAA;IACA,qBAAA;IACA,kBAAA;IACA,WAAA;IACA,kBAAA;EA7B9B;EA+B8B;;;IACI,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;EA3BlC;EA8B8B;;;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,qBAAA;EA1BlC;EA+B8B;IACI,yBAAA;EA7BlC;EAoCc;IACI,WAAA;IACA,YAAA;EAlClB;EAoCkB;IACI,WAAA;IACA,eAAA;EAlCtB;EAoCsB;IACI,iBAAA;EAlC1B;EAsC0B;IACI,UAAA;EApC9B;EAwC8B;IACI,iBAAA;EAtClC;EA4CkB;IACI,cAAA;IACA,gBAAA;EA1CtB;EA4CsB;IACI,YAAA;IACA,gBAAA;EA1C1B;EAkDE;IACI,eAAA;EAhDN;EAkDM;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EAhDV;EAkDU;IACI,mBAAA;EAhDd;EAkDc;IACI,iBAAA;EAhDlB;EAmDc;IACI,iBAAA;IACA,eAAA;EAjDlB;EAqDU;IACI,eAAA;EAnDd;EAwDE;IACI,gBAAA;EAtDN;EAyDU;IACI,UAAA;EAvDd;AACF;AA4DA;EAEQ;IACI,UAAA;EA3DV;EA8DM;IACI,iBAAA;EA5DV;EA+DM;IACI,UAAA;EA7DV;EA+DU;IACI,aAAA;EA7Dd;EAmEM;IACI,iBAAA;EAjEV;EAqEU;IACI,mBAAA;IAEA,sBAAA;EApEd;EAqEc;IACI,WAAA;EAnElB;EAqEkB;IACI,UAAA;IACA,eAAA;EAnEtB;EAqEsB;IACI,iBAAA;EAnE1B;EAuE0B;IACI,UAAA;EArE9B;EA0EkB;IACI,eAAA;EAxEtB;EA0EsB;IACI,WAAA;EAxE1B;EA6Ec;IACI,aAAA;EA3ElB;EA+Ec;IACI,aAAA;IACA,eAAA;IACA,8BAAA;IACA,WAAA;IACA,uBAAA;IACA,kBAAA;EA7ElB;EA+EkB;IACI,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,UAAA;IACA,mBAAA;EA7EtB;EA8EsB;IACI,UAAA;IACA,yBAAA;IACA,cDxhBhB;ICyhBgB,yBAAA;IACA,mBAAA;EA5E1B;EA8E0B;;;IAGI,yBAAA;IACA,qBAAA;IACA,kBAAA;IACA,WAAA;IACA,kBAAA;EA5E9B;EA8E8B;;;IACI,WAAA;IACA,cAAA;EA1ElC;EA6E8B;;;IACI,qBAAA;IACA,eAAA;EAzElC;EA8E8B;IACI,yBAAA;EA5ElC;EAsFE;IACI,eAAA;EApFN;EAsFM;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EApFV;EAsFU;IACI,mBAAA;EApFd;EAsFc;IACI,iBAAA;IACA,eAAA;EApFlB;EAuFc;IACI,iBAAA;EArFlB;EAyFU;IACI,cAAA;EAvFd;AACF;AA4FA;EAEQ;IACI,eAAA;EA3FV;EA+FU;IACI,aAAA;EA7Fd;EAoGU;IACI,aAAA;IACA,8BAAA;IACA,WAAA;EAlGd;EAoGc;IACI,UAAA;EAlGlB;EAoGkB;IAGI,WAAA;EApGtB;EAyGsB;IACI,WAAA;EAvG1B;AACF;AA+GA;EAEQ;IACI,UAAA;EA9GV;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"./variables.scss\";\n\n* {\n    box-sizing: border-box;\n    font-family: \"Roboto\", sans-serif;\n}\n\n.weather {\n    margin-left: -8%;\n}\n\n.main {\n    min-height: 80vh;\n}\n\n.main-heading {\n    margin: 0;\n    margin-bottom: 1vh;\n    text-align: left;\n    padding: 0 2vw;\n    background-image: linear-gradient(to left, #fff, $nitroDark);\n    color: #fff;\n    position: sticky;\n    width: 100%;\n    text-transform: none;\n    font-size: 2rem;\n    @media (max-width: 1000px) {\n        font-size: 1.5rem;\n    }\n    @media (max-width: 600px) {\n        font-size: 1.2rem;\n    }\n}\n\nheader {\n    display: flex;\n    padding: 1% 3%;\n    justify-content: space-between;\n    align-items: center;\n    background-color: $nitroDark;\n\n    .logo {\n        width: 5%;\n    }\n\n    h1 {\n        color: #fff;\n        font-size: 4rem;\n        text-transform: uppercase;\n        cursor: pointer;\n\n        span {\n            color: $nitroLight;\n        }\n    }\n\n    nav {\n        \n        p {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            cursor: pointer;\n\n            &:hover {\n                border-bottom: 1px solid #fff;\n                transform: scale(1.2);\n            }\n        }\n    }\n}\n\nmain {\n    display: flex;\n    flex-direction: column;\n    background-color: $background;\n    overflow-x: none;\n}\n\n.level {\n    min-height: 75vh;\n\n    h2 {\n        text-align: center;\n    }\n\n    .row {\n        display: flex;\n        justify-content: center;\n        width: 90%;\n        margin: auto;\n\n        select {\n            width: 40%;\n            border: 1px solid $nitroLight;\n            border-radius: 1rem;\n            font-size: 1.2rem;\n            background-color: #fff;\n        }\n    }\n\n    .showSite {\n        margin-top: 2%;\n    }\n}\n\n.home {\n    min-height: 75.4vh;\n    @include columnStart;\n    max-width: 100%;\n    .topBar {\n        display: flex;\n        width: 90%;\n        margin: 2% auto;\n        flex-wrap: wrap;\n        @include rowEven;\n\n        .fuelHistory {\n            @include rowEven;\n            // display: flex;\n            flex-wrap: wrap;\n            // justify-content:space-between;\n            width: 50%;\n            // align-items: flex-start;\n\n            .siteHistory {\n                align-items: flex-start;\n                display: flex;\n                flex-direction: column;\n                justify-content: flex-start;\n                width: 50%;\n                align-items: center;\n                table {\n                    width: 90%;\n                    border: 1px solid $fontColor;\n                    color: $fontColor;\n                    border-collapse: collapse;\n                    table-layout: fixed;\n\n                    tr,\n                    th,\n                    td {\n                        border: 1px solid $fontColor;\n                        justify-items: center;\n                        text-align: center;\n                        padding: 1%;\n                        align-self: center;\n\n                        .increase {\n                            color: #0f0;\n                            margin-top: 5%;\n                        }\n\n                        .decrease {\n                            color: rgb(255, 0, 0);\n                            margin-top: 20%;\n                        }\n                    }\n\n                    tr {\n                        &:nth-child(even) {\n                            background-color: #f2f2f2;\n                        }\n                    }\n                }\n            }\n        }\n\n        .rightSide {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            width: 30vw;\n\n            .current {\n                width: 90%;\n                margin: auto;\n                border-radius: 1rem;\n                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n                display: flex;\n                flex-direction: column;\n                margin: 2% 0;\n                background-color: #fff;\n\n                b {\n                    text-align: center;\n                    color: $fontColor;\n                }\n\n                .prices {\n                    display: flex;\n                    justify-content: space-evenly;\n                    align-items: center;\n\n                    .latest {\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n\n                        p {\n                            display: flex;\n                            justify-content: center;\n                            align-items: center;\n                        }\n                    }\n\n                    img {\n                        width: 5%;\n                    }\n\n                    &:nth-child(1) {\n                        justify-content: center;\n                    }\n                }\n            }\n\n            .wrapper {\n                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n                height: 350px;\n\n                .chart {\n                    width: 44vw;\n                }\n            }\n        }\n    }\n}\n\n.sites {\n    min-height: 74.8vh;\n    display: flex;\n    justify-content: space-evenly;\n    width: 100%;\n    margin: 3% auto;\n\n    .banner {\n        border: 5px solid #000;\n        border-radius: 0.5rem;\n        width: 12vw;\n        height: 100vh;\n        color: #fff;\n        cursor: pointer;\n        // display:grid;\n        display: flex;\n        flex-direction: column;\n        position: relative;\n\n        .bpSite {\n            font-family: \"digital-clock-font\";\n            background-color: black;\n            color: white;\n            text-align: center;\n            margin-top: -4px;\n            margin-bottom: 15px;\n            font-size: 1.7rem;\n        }\n\n        .bottom {\n            align-self: flex-end;\n            position: absolute;\n            bottom: 0;\n        }\n\n        .indvPrice {\n            display: flex;\n            justify-content: space-between;\n            margin-bottom: -15%;\n\n            .fuelType {\n                font-size: 1.2rem;\n                margin-top: 25%;\n            }\n\n            .bpBoard {\n                font-family: \"digital-clock-font\";\n                background-color: black;\n                color: white;\n                font-size: 3rem;\n            }\n        }\n    }\n}\n\nfooter {\n    display: flex;\n    justify-content: center;\n    background-color: $nitroDark;\n    p {\n        color: #fff;\n\n        a {\n            text-decoration: none;\n            color: $nitroLight;\n        }\n    }\n}\n\n@media (max-width: $mobile) {\n    header {\n        .logo {\n            width: 30%;\n        }\n\n        h1 {\n            font-size: 1.2rem;\n        }\n\n        nav {\n            width: 50%;\n\n            span {\n                display: none;\n            }\n        }\n    }\n\n    main {\n        h2 {\n            font-size: 1.2rem;\n        }\n\n        .home {\n            .topBar {\n                // flex-wrap: wrap;\n                flex-direction: column;\n\n                .fuelHistory {\n                    display: flex;\n                    flex-wrap: wrap;\n                    justify-content: space-between;\n                    width: 85vw;\n                    align-items: flex-start;\n                    margin-right: auto;\n\n                    .siteHistory {\n                        align-items: flex-start;\n                        display: flex;\n                        flex-direction: column;\n                        justify-content: flex-start;\n                        width: 100vw;\n                        align-items: center;\n                        table {\n                            width: 90%;\n                            border: 1px solid $fontColor;\n                            color: $fontColor;\n                            border-collapse: collapse;\n                            table-layout: fixed;\n\n                            tr,\n                            th,\n                            td {\n                                border: 1px solid $fontColor;\n                                justify-items: center;\n                                text-align: center;\n                                padding: 1%;\n                                align-self: center;\n\n                                .increase {\n                                    color: #0f0;\n                                    display: flex;\n                                    flex-direction: column;\n                                    align-items: center;\n                                    justify-content: center;\n                                }\n\n                                .decrease {\n                                    display: flex;\n                                    flex-direction: column;\n                                    align-items: center;\n                                    justify-content: center;\n                                    color: rgb(255, 0, 0);\n                                }\n                            }\n\n                            tr {\n                                &:nth-child(even) {\n                                    background-color: #f2f2f2;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .rightSide {\n                    width: 90vw;\n                    margin: auto;\n\n                    .current {\n                        width: 100%;\n                        margin: 2% auto;\n\n                        p {\n                            font-size: 0.8rem;\n                        }\n\n                        .prices {\n                            img {\n                                width: 20%;\n                            }\n\n                            .latest {\n                                p {\n                                    font-size: 0.7rem;\n                                }\n                            }\n                        }\n                    }\n\n                    .wrapper {\n                        margin-top: 3%;\n                        overflow: hidden;\n\n                        .chart {\n                            border: none;\n                            margin-left: -7%;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .sites {\n        flex-wrap: wrap;\n\n        .banner {\n            width: 40vw;\n            height: 82vh;\n            margin-bottom: 3%;\n\n            .indvPrice {\n                margin-bottom: -42%;\n\n                .fuelType {\n                    font-size: 0.9rem;\n                }\n\n                .bpBoard {\n                    font-size: 2.5rem;\n                    margin-top: 20%;\n                }\n            }\n\n            .bottom {\n                margin-top: 10%;\n            }\n        }\n    }\n\n    .level {\n        min-height: 80vh;\n\n        .row {\n            select {\n                width: 60%;\n            }\n        }\n    }\n}\n\n@media (min-width: #{$mobile}) and (max-width: #{$laptop}) {\n    header {\n        .logo {\n            width: 30%;\n        }\n\n        h1 {\n            font-size: 1.2rem;\n        }\n\n        nav {\n            width: 50%;\n\n            span {\n                display: none;\n            }\n        }\n    }\n\n    main {\n        h2 {\n            font-size: 1.2rem;\n        }\n\n        .home {\n            .topBar {\n                align-items: center;\n                // flex-wrap: wrap;\n                flex-direction: column;\n                .rightSide {\n                    width: 80vw;\n\n                    .current {\n                        width: 95%;\n                        margin: 2% auto;\n\n                        p {\n                            font-size: 0.8rem;\n                        }\n\n                        .prices {\n                            img {\n                                width: 20%;\n                            }\n                        }\n                    }\n\n                    .wrapper {\n                        margin: 2% auto;\n\n                        .chart {\n                            width: 85vw;\n                        }\n                    }\n                }\n\n                .weather {\n                    display: none;\n                    // margin: auto;\n                }\n\n                .fuelHistory {\n                    display: flex;\n                    flex-wrap: wrap;\n                    justify-content: space-between;\n                    width: 90vw;\n                    align-items: flex-start;\n                    margin-bottom: 5vh;\n\n                    .siteHistory {\n                        align-items: flex-start;\n                        display: flex;\n                        flex-direction: column;\n                        justify-content: flex-start;\n                        width: 50%;\n                        align-items: center;\n                        table {\n                            width: 90%;\n                            border: 1px solid $fontColor;\n                            color: $fontColor;\n                            border-collapse: collapse;\n                            table-layout: fixed;\n\n                            tr,\n                            th,\n                            td {\n                                border: 1px solid $fontColor;\n                                justify-items: center;\n                                text-align: center;\n                                padding: 1%;\n                                align-self: center;\n\n                                .increase {\n                                    color: #0f0;\n                                    margin-top: 5%;\n                                }\n\n                                .decrease {\n                                    color: rgb(255, 0, 0);\n                                    margin-top: 20%;\n                                }\n                            }\n\n                            tr {\n                                &:nth-child(even) {\n                                    background-color: #f2f2f2;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .sites {\n        flex-wrap: wrap;\n\n        .banner {\n            width: 48vw;\n            height: 82vh;\n            margin-bottom: 3%;\n\n            .indvPrice {\n                margin-bottom: -20%;\n\n                .fuelType {\n                    font-size: 1.5rem;\n                    margin-top: 16%;\n                }\n\n                .bpBoard {\n                    font-size: 3.5rem;\n                }\n            }\n\n            .bottom {\n                margin-top: 5%;\n            }\n        }\n    }\n}\n\n@media (min-width: #{$tablet}) and (max-width: #{1025px}) {\n    header {\n        h1 {\n            font-size: 2rem;\n        }\n\n        nav {\n            span {\n                display: none;\n            }\n        }\n    }\n\n    .main {\n        .home {\n            .topBar {\n                display: flex;\n                justify-content: space-between;\n                width: 95vw;\n\n                .rightSide {\n                    width: 40%;\n\n                    .current {\n                        // width: 90%;\n                        // margin: 2% auto 50% auto;\n                        width: 100%;\n                    }\n\n                    .wrapper {\n                        // margin: 0% 0 3% -20%;\n                        .chart {\n                            width: 40vw;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (min-width: $laptop) {\n    header {\n        .logo {\n            width: 25%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
